import cn from 'classnames';

import type { PostAudioElementProps } from './PostAudio.types';

export function PostAudioElement(props: PostAudioElementProps) {
  const { element, children, attributes, isLive } = props;

  const { data, elementId, padding } = element.attrs;

  return (
    <div className={cn('w-full', !isLive && 'pointer-events-none')} {...attributes}>
      <div className="w-full flex items-center" style={{ padding }}>
        {/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
        <audio controls preload="auto" className="w-full" id={elementId}>
          <source src={data.audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>

      {children}
    </div>
  );
}
